<template>
  <div id="secondSectionContainer">
    <div class="jackpotContainer">
      <div class="jackpotText blink-1">
        <span v-if="this.langChosen === 'gr'">ชุดการเดิมพัน</span>
        <span v-else>Jackpot Value</span>
      </div>
      <div class="jackpotNumber">฿{{ this.dataHariIni.jackpotValue | thousandSeparator }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataHariIni'],
  filters: {
    thousandSeparator: function(numbers) {
      if (numbers === undefined || numbers === '' || numbers === null) {
        return '';
      } else {
        let result = '';
        let counter = 0;
        for (let i = numbers.toString().length; i >= 0; i--) {
          if (counter % 3 === 0 && counter !== 0 && counter !== numbers.toString().length) {
            result = ',' + numbers.toString().substr(i, 1) + result;
          } else {
            result = numbers.toString().substr(i, 1) + result;
          }
          counter += 1;
        }
        return result;
      }
    },
  },
};
</script>

<style>
#secondSectionContainer {
  padding: 13vw 10vw;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  background: url('../assets/chips.jpg');
  background-size: 50vw;
  background-repeat: no-repeat;
  background-position-x: 65vw;
  background-color: white;
}

.jackpotText {
  font-size: 1.5em;
  font-weight: 600;
  color: var(--yellowPrim-lighter-1);
}

.jackpotNumber {
  font-size: 3em;
  font-weight: 600;
  color: var(--primary);
  animation: 5s infinite linear slidein;
}

.gambarChips {
  width: 75vmin;
  position: relative;
  right: 15vmin;
  z-index: -1;
}

.jackpotContainer {
  overflow: hidden;
}

@keyframes slidein {
  from {
    margin-left: 100%;
  }

  to {
    margin-left: -100%;
  }
}

.blink-1 {
  -webkit-animation: blink-1 2s infinite both;
  animation: blink-1 3s infinite both;
}

/* ----------------------------------------------
 * Generated by Animista on 2019-8-19 17:18:57
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation blink-1
 * ----------------------------------------
 */
@-webkit-keyframes blink-1 {
  0%,
  25%,
  50%,
  75%,
  100% {
    opacity: 1;
  }
  20%,
  45%,
  70% {
    opacity: 0;
  }
}

@keyframes blink-1 {
  0%,
  6%,
  12%,
  18%,
  24% {
    opacity: 1;
  }

  4%,
  10%,
  16%,
  22% {
    opacity: 0;
  }
}

@media screen and (min-width: 768px) {
  #secondSectionContainer {
    padding: 75px 300px;
    background-size: 300px;
    background-position-y: -15px;
    background-position-x: 800px;
  }

  .jackpotText {
    font-size: 2em;
  }

  .jackpotNumber {
    font-size: 4em;
  }

  .jackpotContainer {
    width: 600px;
  }
}
</style>
